import performRequest from "../Api/request";
  

  export const getRandomNews = async () => {
    try {
      const response = await performRequest("GET", "/blog/random-post");
  
      return response.data.blogs || [];
    } catch (error) {
      console.error("Error fetching random posts:", error);
      return [];
    }
  };
  
  

  export const getLatestNews = async () => {
    try {
      const response = await performRequest("GET", "/blog/latest-post");
     
      return response.data.blogs || [];
    } catch (error) {
      console.error("Error fetching latest posts:", error);
      return [];
    }
  };
  export const getPostsByCategory = async (category) => {
    try {
      const response = await performRequest("GET", `/blog/category-post/${category}`);
      return response.blogs || [];
    } catch (error) {
      return [];
    }
  };
  
  export const getFiveTrendingPosts = async () => {
    try {
      const response = await performRequest("GET", "/blog/trending-post");
      return response.blogs || [];
    } catch (error) {
      return [];
    }
  };
  
  export const getBlogBySlug = async (slug) => {
    try {
      const response = await performRequest("GET", `/blog/blog-slug/${slug}`);
      return response?.data?.blog || [];
    } catch (error) {
      return [];
    }
  };